import { FccVersionEntityConfig }  from '@app/modules/fcc-version/presets/fcc-version-entity-config.model';
import {
	TssModeEnum,
	TssModeSubTypeEnum
}                                  from '@app/modules/tss/models/tss.model';
import { RequestState }            from '@core/interfaces/api.interface';
import { IFccVersionEntityEvents } from '@core/interfaces/entity.interface';
import { EntityActionEventEnum }   from '@models/entity.model';
import { LanguagesSupportedType }  from '@models/language';

// ENUMS #############################################################
// API enums *********************************************************
export enum FccVersionStatusEnum {
	LATEST = 'latest',
	NOT_RECOMMENDED = 'notRecommended',
	RECOMMENDED = 'recommended',
	UNSUPPORTED = 'unsupported'
}

// UI enums *********************************************************
export enum FccVersionPresetEnum {
	ADMIN_FCC_VERSION = 'adminFccVersion',
	TASK_CENTER_FCC_VERSION = 'taskCenterFccVersion'
}

// TYPES #############################################################
export type FccVersionProps = ( keyof FccVersion )[];


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface IFccVersionEntityActionEvent {
	action: EntityActionEventEnum;
	fccVersion: FccVersion;
	fccVersionEntityConfig?: FccVersionEntityConfig;
	fccVersionTssModeStatus?: FccVersionTssModeStatus;
}

// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class FccVersionTMO {
	public comments?: FccVersionComments = new FccVersionComments();
	public id: string = undefined;
	public statuses?: FccVersionTssModeStatus[] = undefined;
	public version: string = undefined;
}

export class FccVersionTssModeStatusTMO {
	public mode: TssModeEnum = undefined;
	public modeSubtype?: TssModeSubTypeEnum = undefined;
	public status?: FccVersionStatusEnum = undefined;
}

export class FccVersionBodyTMO {
	public comments?: FccVersionComments = new FccVersionComments();
	public statuses?: FccVersionTssModeStatus[] = undefined;
	public version: string = undefined;
}

export class FccVersionInfoTMO {
	public [ FccVersionStatusEnum.LATEST ]: FccVersion[] = undefined;
	public [ FccVersionStatusEnum.NOT_RECOMMENDED ]: FccVersion[] = undefined;
	public [ FccVersionStatusEnum.RECOMMENDED ]: FccVersion[] = undefined;
	public [ FccVersionStatusEnum.UNSUPPORTED ]: FccVersion[] = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class FccVersion extends FccVersionTMO {
	public count?: number = undefined;
	public etag?: string = undefined;

	public ui?: IFccVersionEntityEvents = {
		requestState: RequestState.NOT_ASKED,
		requestError: undefined,
		entityActions: {}
	};
}

export class FccVersionComments implements LanguagesSupportedType {
	public de: string = undefined;
	public en: string = undefined;
}

export class FccVersionInfo extends FccVersionInfoTMO {}

export class FccVersionTssModeStatus extends FccVersionTssModeStatusTMO {
	count?: number;
}
